import React, { Component } from 'react';
import {
  Navbar,
  Nav,
  NavItem,
  Grid,
  NavDropdown,
  MenuItem
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { connect } from 'react-redux';
import { signoutUser } from '../../actions';
import './NavBar.css';


class NavBar extends Component {

  render() {
    if (!this.props.auth.authenticated) return null;

    return (
      <Grid fluid className="nav-container">
        <Navbar fixedTop collapseOnSelect>
          <Navbar.Header>
            <Navbar.Brand>
              <div>SCM Tracker</div>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
          <Nav>
            <LinkContainer to="/dashboard">
              <NavItem eventKey={1}>
                Dashboard
              </NavItem>
            </LinkContainer>
            <LinkContainer to="/stats">
              <NavItem eventKey={2}>
                Stats
              </NavItem>
            </LinkContainer>
            <LinkContainer to="/tradehistory">
              <NavItem eventKey={3}>
                Trade History
              </NavItem>
            </LinkContainer>
          </Nav>
          <Nav pullRight>
            <NavDropdown eventKey={3} title={this.props.session.currentUser} id="basic-nav-dropdown">
              <LinkContainer to="/signout" >
                <MenuItem eventKey={3.1}>
                  Logout
                </MenuItem>
              </LinkContainer>
            </NavDropdown>
          </Nav>
          </Navbar.Collapse>
      </Navbar>
    </Grid>
    );
  }
}

function mapStateToProps ({ auth, session }) {
  return {
    auth,
    session
  }
}

export default connect(mapStateToProps, { signoutUser })(NavBar);
